<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'General',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'First title',
              modelPath: [this, 'form', 'first_title'],
              multilingual: true,
              required: true
            }),
            new fields.Input({
              label: 'First subtitle',
              modelPath: [this, 'form', 'first_subtitle'],
              multilingual: true,
              required: true
            }),
            new fields.Switch({
              label: 'Is first title green',
              modelPath: [this, 'form', 'first_title_is_green']
            }),
            new fields.Input({
              label: 'First description',
              modelPath: [this, 'form', 'first_description'],
              multilingual: true,
              type: 'textarea',
              required: true
            }),
            new fields.Input({
              label: 'Second title',
              modelPath: [this, 'form', 'second_title'],
              multilingual: true,
              required: true
            }),
            new fields.Input({
              label: 'Second subtitle',
              modelPath: [this, 'form', 'second_subtitle'],
              multilingual: true,
              required: true
            }),
            new fields.Switch({
              label: 'Is second title green',
              modelPath: [this, 'form', 'second_title_is_green']
            }),
            new fields.Input({
              label: 'Second description',
              modelPath: [this, 'form', 'second_description'],
              multilingual: true,
              type: 'textarea',
              required: true
            })
          ]
        }
      ]
    }
  }
}
</script>
